import { render, staticRenderFns } from "./ServicesHotLine.vue?vue&type=template&id=ac10526a&scoped=true"
import script from "./ServicesHotLine.vue?vue&type=script&lang=js"
export * from "./ServicesHotLine.vue?vue&type=script&lang=js"
import style0 from "./ServicesHotLine.vue?vue&type=style&index=0&id=ac10526a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac10526a",
  null
  
)

export default component.exports